module.exports = __webpack_public_path__ + "img/KBANK.f746cec8.png";